import type { FaireProductEntity } from "../../entity_types/product";

export const p_s39m896u53: FaireProductEntity = {
  token: "p_s39m896u53",
  type: "product",
  name: "Horse Girl Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/08095c08d8705f5d620a6aa7c60c622951efe8961bb4c5db9b2c66d8650879e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1100c70050ebfd2724751e2c683a72a36a8f425f9c12a1c826d3a8d8559b4828.jpeg",
    "https://cdn.faire.com/fastly/cc008b6b3a306a832e78c3388d2bbf55f33534ba9f774db50c33172ab4a67d70.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/5d4e3d1976f01ddd2549a909763bf74adaa51b87edfbb82fc678a8b6d6294e85.jpeg",
    "https://cdn.faire.com/fastly/41117fb3204d461868e23db313abe199ab511dbd4400e87f28a87c8b665c99e8.jpeg"
  ],
  priceDollars: 6.75,
  description: "Quirky on the surface, yet unmistakably driven underneath. And you've maybe tried hay before just to see what that was all about. Pinnacle Horse Girl Behavior.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:59.107Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
